import { Capacitor } from '@capacitor/core';

/**
 * Utility functions for detecting the platform and environment
 */

export const isNativePlatform = (): boolean => {
  return Capacitor.isNativePlatform();
};

export const isIOS = (): boolean => {
  return Capacitor.getPlatform() === 'ios';
};

export const isAndroid = (): boolean => {
  return Capacitor.getPlatform() === 'android';
};

export const isWeb = (): boolean => {
  return Capacitor.getPlatform() === 'web';
};

export const getPlatform = (): string => {
  return Capacitor.getPlatform();
};

/**
 * Check if running in Capacitor native app
 */
export const isCapacitorApp = (): boolean => {
  return isNativePlatform();
};
